var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"payments-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.payments),function(payment){return _c('i-col',{key:payment.id,attrs:{"span":"24"}},[_c('payments-item',{attrs:{"payment":payment,"all":_vm.all},on:{"open-payment":_vm.openPayment}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }